/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AbstractSchemaBean } from './AbstractSchemaBean';
import {
    AbstractSchemaBeanFromJSON,
    AbstractSchemaBeanFromJSONTyped,
    AbstractSchemaBeanToJSON,
} from './AbstractSchemaBean';

/**
 * 
 * @export
 * @interface ProductAttribute
 */
export interface ProductAttribute {
    /**
     * 
     * @type {string}
     * @memberof ProductAttribute
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAttribute
     */
    isChecked?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductAttribute
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductAttribute
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAttribute
     */
    notes?: string;
}

/**
 * Check if a given object implements the ProductAttribute interface.
 */
export function instanceOfProductAttribute(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductAttributeFromJSON(json: any): ProductAttribute {
    return ProductAttributeFromJSONTyped(json, false);
}

export function ProductAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAttribute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'isChecked': !exists(json, 'isChecked') ? undefined : json['isChecked'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function ProductAttributeToJSON(value?: ProductAttribute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'isChecked': value.isChecked,
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

